import {showNotification} from '../utils/events';

export type NotificationVariants = keyof typeof showNotification;
